"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var serviceRoute = '/custom-attributes-service';
exports.Routes = {
    SERVICE_ROUTE: "".concat(serviceRoute, "/v1/custom-attributes"),
    DELETE: "".concat(serviceRoute, "/v1/custom-attributes/{:id}")
};
//# sourceMappingURL=CustomAttributes.consts.js.map